import { render, staticRenderFns } from "./entrepreneurPending.vue?vue&type=template&id=59d25578&scoped=true"
import script from "./entrepreneurPending.vue?vue&type=script&lang=js"
export * from "./entrepreneurPending.vue?vue&type=script&lang=js"
import style0 from "./entrepreneurPending.vue?vue&type=style&index=0&id=59d25578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d25578",
  null
  
)

export default component.exports